import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import {
  Tramite,
  Microproceso,
  HistorialMicroproceso,
  ConsultaTramite,
  Filtro,
  EstructuraEspecifica,
  ValoresEspecificos,
  ModeloBase
} from '@app/shared';
import { Logger, EndpointService } from '@app/core';
import { Const } from '@app/shared';

const log = new Logger('FlowService');

@Injectable()
export class FlowService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Retorna los tramites por default con sus actividades.
   *
   * @param {number} idDefaultTramite
   * @returns {Observable<ConsultaTramite[]>}
   * @memberof FlowService
   */
  getInstanceDefaultTramites(idDefaultTramite: number, filters?: any): Observable<ConsultaTramite[]> {
    return new Observable(obs => {
      const dataForm = {
        id: idDefaultTramite
      };
      if (filters) {
        dataForm['filtros'] = filters;
      }
      this.http.post<ConsultaTramite[]>(this.api.get('instanceDefaultTramite'), dataForm).subscribe(
        instances => {
          obs.next(instances);
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna una instancia de un microproceso.
   *
   * @param {number} idTarea
   * @returns {Observable<Microproceso>}
   * @memberof FlowService
   */
  getMicroProcess(idTarea: number): Observable<Microproceso> {
    return new Observable(obs => {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.workflowMicroproces;
      this.http.get<Microproceso>(this.api.addParams(path, 'simple', [idTarea])).subscribe(
        instance => {
          obs.next(instance);
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna una instancia de un tramite por default.
   *
   * @param {number} idTramite
   * @returns {Observable<Tramite>}
   * @memberof FlowService
   */
  getInstance(idTramite: number): Observable<Tramite> {
    return new Observable(obs => {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.workflow;
      this.http.get<Tramite>(this.api.addParams(path, 'simple', [idTramite])).subscribe(
        instance => {
          obs.next(instance);
          obs.complete();
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta el historial de versiones de un microproceso
   *
   * @param {number} idTask
   * @returns {Promise<HistorialMicroproceso[]>}
   * @memberof FlowService
   */
  getHistoryMicroproces(idTask: number): Promise<HistorialMicroproceso[]> {
    return new Promise((resolve, reject) => {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.workflowMicroprocesHistory;
      this.http.get<HistorialMicroproceso[]>(this.api.addParams(path, 'simple', [idTask])).subscribe(
          historyMicroproces => {
            resolve(historyMicroproces);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta los filtros para la consulta de el tramite
   *
   * @param {number} idTramite
   * @returns {Promise<Filtro>}
   * @memberof FlowService
   */
  getFiltersShearchTramite(idTramite: number): Promise<Filtro> {
    return new Promise((resolve, reject) => {
      this.http.get<Filtro>(this.api.get('filterTramiteParameter', [idTramite])).subscribe(
          filter => {
            resolve(filter);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Consulta una maestra sus columnas en especifico
   *
   * @param {EstructuraEspecifica} structure
   * @returns {Promise<ValoresEspecificos[]>}
   * @memberof FlowService
   */
  getColumnsSpecificMasterTable(
    structure: EstructuraEspecifica,
  ): Promise<ValoresEspecificos[]> {
    return new Promise((resolve, reject) => {
      const formData = {
        estructura: structure
      };
      this.http.post<ValoresEspecificos[]>(this.api.get('masterTableSpecificInformation'), formData).subscribe(
          specificValues => {
            resolve(specificValues);
          },
          err => {
            reject(err);
          }
        );
    });
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-flow/shared/flow.service.ts